// extracted by mini-css-extract-plugin
export default {"cookieBar":"CookieConsent_cookieBar__kEJyj","actions":"CookieConsent_actions__b6TC1","accept":"CookieConsent_accept__+KEGz","decline":"CookieConsent_decline__xOill"};